import React from "react";
import "./Introduction.css";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { ThemeContext } from "../../Context/theme";
import img from "../../Assets/home.png";

export const Introduction = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <div id="aboutt" className="about section" >
      <section id="#aboutt" >
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About <span className="different" id="my">Me</span>
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img className="home-img"
                src={img}
                alt="Images"
              />
            </div>
            <div className="introduction_datacontainer">
              <h4 id="user-detail-intro">
                Hi Everyone, I am{" "}
                <span className="different">Ruchi Priya Kumari</span> from{" "}
                <span className="different"> New Delhi</span>. 
                A Passionate <span className="different">Full Stack Web Developer</span>  with hands-on
                experience in developing scalable websites/application
                using a wide range of front-end and back-end skills like
                HTML,CSS,Javascript. Highly skilled in design,
                development and implementation of functional specifications.
                I have completed my graduation in <span className="different"> Bachelor of Computer Application</span>
                and Post graduation in<span className="different"> Master of Computer Application</span>  from
                Indira Gandhi National Open University Delhi.

             </h4>
              <h4 className="head">Some of my interests apart form Coding :</h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Art & Craft{" "}
              </h4>
              {/* <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Listening to Music{" "}
              </h4> */}
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Cooking{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Travelling{" "}
              </h4>

              {/* <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Watching Web-series{" "}
              </h4> */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
